module.exports = __webpack_public_path__ + "img/golfigo.315955e0.png";